<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card tile>
        <v-card-title>
          <h3>Commissions</h3>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-data-table
            :items="caseLogManagersFlow"
            :headers="managersTableHeaders"
            disable-initial-sort
            no-data-text="No managers"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.created_at || caseModel.created_at }}</td>
              <td>{{ props.item.manager.name + ' (' + props.item.manager.email + ')' }}</td>
              <td :class="canAddCommissions ? 'quantity_bgcolor' : ''">
                <v-edit-dialog
                  large
                  lazy
                  persistent
                >
                  <div v-if="caseModel.status === 'closed'">${{ props.item.commissions }}</div>
                  <div v-else="caseModel.status === 'closed'">Case not closed</div>
                  <template v-slot:input>
                    <div class="mt-3 title">Update Commissions</div>
                  </template>
                  <template v-slot:input v-if="canAddCommissions">
                    <v-text-field
                      v-model="props.item.commissions"
                      label="Commissions"
                      @change="updateCommissions"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      caseModel: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        caseLogManagersFlow: 'caseLogManagersFlow',
        casesWithServicesCommissions: 'casesWithServicesCommissions'
      }),
      canAddCommissions () {
        return this.$can('add', 'new-commissions-to-case-manager')
      }
    },
    data () {
      return {
        snackbar: false,
        loading: false,
        managersTableHeaders: [
          { text: 'Appointment date', value: 'created_at', sortable: true },
          { text: 'Name' },
          { text: 'Commissions', value: 'commissions' }
        ]
      }
    },
    watch: {
      caseModel (c) {
        if (this.$store.state.cases.caseLog.length === 0) this.$store.dispatch('getCaseLog', c.id)
      }
    },
    methods: {
      updateCommissions (v) {
        this.$store.dispatch('changeCaseManagerCommissions', {
          case_id: this.caseModel.id,
          commissions: v
        }).then(() => {
          this.$store.dispatch('getCaseLog', this.caseModel.id)
        })
      }
    },
    created () {
      if (this.$store.state.cases.caseLog.length === 0) this.$store.dispatch('getCaseLog', this.caseModel.id)
    }
  }
</script>



// WEBPACK FOOTER //
// CaseCommissions.vue?b67015b0